import React, { useState, cloneElement } from 'react';
import { CModal, CModalHeader, CModalBody, CModalTitle, CModalFooter } from '@coreui/react';
import { Button } from '../button/Button';
import { NotificationType } from '@transferz/models';

interface IPopConfirmProps {
  children: any;
  title: string;
  bodyText: string;
  onConfirm: () => void;
  onCancel?: () => void;
  confirmText?: string;
  cancelText?: string;
  modalColor?: NotificationType;
}

export const PopConfirm: React.FunctionComponent<IPopConfirmProps> = ({
  children,
  title,
  bodyText,
  onConfirm,
  onCancel = () => {},
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  modalColor = NotificationType.Danger,
}) => {
  const [show, setShow] = useState(false);
  return (
    <>
      { cloneElement( children, { onClick: () => setShow(true) } ) }
      <CModal
        show={show}
        onClose={() => setShow(false)}
        color={modalColor}
      >
        <CModalHeader closeButton>
          <CModalTitle>{title}</CModalTitle>
        </CModalHeader>
        <CModalBody className="text-left">
          {bodyText}
        </CModalBody>
        <CModalFooter>
          <Button title={cancelText} color="secondary" onClick={() => {
            setShow(false);
            (onCancel as Function)();
          }} />
          <Button title={confirmText} color="danger" onClick={() => {
            onConfirm();
            setShow(false);
          }} />
        </CModalFooter>
      </CModal>
    </>
  )
};
